var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    fill: "#0F5EFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9375 5.9375H7.27344L8.16406 5.04688H10.8359L11.7266 5.9375H13.0625C13.2987 5.9375 13.5252 6.03133 13.6923 6.19836C13.8593 6.36538 13.9531 6.59192 13.9531 6.82812V12.1719C13.9531 12.4081 13.8593 12.6346 13.6923 12.8016C13.5252 12.9687 13.2987 13.0625 13.0625 13.0625H5.9375C5.70129 13.0625 5.47476 12.9687 5.30773 12.8016C5.14071 12.6346 5.04688 12.4081 5.04688 12.1719V6.82812C5.04688 6.59192 5.14071 6.36538 5.30773 6.19836C5.47476 6.03133 5.70129 5.9375 5.9375 5.9375ZM9.5 7.27344C8.90948 7.27344 8.34314 7.50802 7.92558 7.92558C7.50802 8.34314 7.27344 8.90948 7.27344 9.5C7.27344 10.0905 7.50802 10.6569 7.92558 11.0744C8.34314 11.492 8.90948 11.7266 9.5 11.7266C10.0905 11.7266 10.6569 11.492 11.0744 11.0744C11.492 10.6569 11.7266 10.0905 11.7266 9.5C11.7266 8.90948 11.492 8.34314 11.0744 7.92558C10.6569 7.50802 10.0905 7.27344 9.5 7.27344ZM9.5 8.16406C9.85431 8.16406 10.1941 8.30481 10.4447 8.55535C10.6952 8.80589 10.8359 9.14569 10.8359 9.5C10.8359 9.85431 10.6952 10.1941 10.4447 10.4447C10.1941 10.6952 9.85431 10.8359 9.5 10.8359C9.14569 10.8359 8.80589 10.6952 8.55535 10.4447C8.30481 10.1941 8.16406 9.85431 8.16406 9.5C8.16406 9.14569 8.30481 8.80589 8.55535 8.55535C8.80589 8.30481 9.14569 8.16406 9.5 8.16406Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.817bdded4ea1cefd7e72f64fdaea332b.svg";
export { ForwardRef as ReactComponent };